import React from 'react';
interface SectionHeadingProps {
  /* omitted for sections that are not part of the numbered run */
  index?: string;
  title: string;
  note?: string;
  locked?: boolean;
  children?: React.ReactNode;
}
export function SectionHeading({
  index,
  title,
  note,
  locked = false,
  children
}: SectionHeadingProps) {
  return <div data-id="element-236" data-mp="3k185rt1qf4dc">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-baseline sm:justify-between" data-id="element-237" data-mp="3k0yhc9wc559r">
        <div className="flex items-baseline gap-4" data-id="element-238" data-mp="bloj5cvkgk79">
          {index ? <span className={`tnum font-sans text-[12px] font-semibold tracking-[0.18em] ${locked ? 'text-navy/35' : 'text-[#B07E00]'}`} data-id="element-239" data-mp="gjzuxt5f94s4">
              {index}
            </span> : null}
          <h2 className={`font-display text-[30px] font-semibold leading-tight sm:text-[38px] ${locked ? 'text-navy/50' : 'text-navy'}`} data-id="element-240" data-mp="6rk9glux1y2h">
            {title}
          </h2>
        </div>
        {children}
      </div>
      {note ? <p className={`mt-3 max-w-[40rem] font-sans text-[16px] leading-relaxed ${locked ? 'text-navy/45' : 'text-navy/65'} ${index ? 'sm:ml-[42px]' : ''}`} data-id="element-241" data-mp="1ta8q3ka4qpqa">
          {note}
        </p> : null}
    </div>;
}